module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAKpJREFUWAntljEOgCAMRSk6eCu9lbOjt9JbuZg6mDIZaEoMDfksHfiF9pU2hIAFAiAAAr8SIO3p9zqxVqvVDftVvD9qD2ulQ4C15N0THK0ZEtHJgQ6tPwVemHnW6kXXL8GXhp6IdUa5J4gA5bFbrXuC1WMmjQ+KW45S0uVEH3vuCRZ/E5JUq98MSiwVsFqUWMihi1t1sfs5iAClSazWPUFrYvADARAAgV4IPPV/QLIyfUXIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/orders.png
// module id = 436
// module chunks = 0